<template>
  <!-- ===================== -->
  <!-- Main Card -->
  <!-- ===================== -->
  <b-card no-body>

    <!-- ===================== -->
    <!-- Support Contacts Card -->
    <!-- ===================== -->
    <b-card class="m-2 shadow-sm border">
      <h5 class="mb-2">Court Support Contacts</h5>

      <b-list-group flush>
        <b-list-group-item
          v-for="contact in contacts"
          :key="contact.number"
          class="d-flex justify-content-between align-items-center"
        >
          <span>
            {{ contact.name }} ({{ contact.number }})
          </span>

          <div>
            <!-- Call -->
            <b-button
              size="sm"
              variant="primary"
              class="mr-1"
              @click="call(contact.number)"
            >
             <feather-icon
              icon="PhoneIcon"
              size="16"
            />

            </b-button>

            <!-- WhatsApp -->
            <b-button
              size="sm"
              variant="success"
              @click="whatsapp(contact.number)"
            >
              <feather-icon
                icon="MessageCircleIcon"
                size="16"
              />
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>


    <!-- ===================== -->
    <!-- Ticket Header Section -->
    <!-- ===================== -->
    <div class="m-2">
      <b-row>
        <b-col
          cols="4"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <h5>Support Tickets</h5>
        </b-col>

        <b-col cols="8">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-col cols="6" lg="4">
              <v-select
                v-model="statusFilter"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="(val) => val.value"
                class="invoice-filter-select"
                placeholder="Select Status"
              />
            </b-col>

            <generate-ticket @refetch-data="refetchData" />
          </b-row>
        </b-col>
      </b-row>
    </div>


    <!-- ===================== -->
    <!-- Ticket Table -->
    <!-- ===================== -->
    <b-overlay
      :show="$store.state.ticketStore.ticketLoading"
      rounded="sm"
      variant="transparent"
      opacity="0.5"
      blur="2px"
    >
      <b-table
        ref="refInvoiceListTable"
        :items="fetchTickets"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        show-empty
        empty-text="No matching records found"
        class="position-relative"
      >
        <!-- Date -->
        <template #cell(datetime)="data">
          {{ getDate(data.item.datetime) }}
        </template>

        <!-- Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="data.item.status === 'PENDING' ? 'primary' : 'info'"
          >
            {{ data.item.status }}
          </b-badge>
        </template>
      </b-table>
    </b-overlay>


    <!-- ===================== -->
    <!-- Pagination -->
    <!-- ===================== -->
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries
          </span>
        </b-col>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalInvoices"
            :per-page="perPage"
            first-number
            last-number
          />
        </b-col>
      </b-row>
    </div>

  </b-card>
</template>


<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BOverlay,
  BListGroup,
  BListGroupItem
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import moment from 'moment'
import GenerateTicket from './GenerateTicket.vue'
import useSupportTicket from './useSupportTicket'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BOverlay,
    BListGroup,
    BListGroupItem,
    GenerateTicket,
    vSelect
  },

  methods: {
    getDate(date) {
      return moment(date).format('lll')
    },

    call(number) {
      window.location.href = `tel:+91${number}`
    },

    whatsapp(number) {
      const text = encodeURIComponent('My Munshi App\nNeed Support\n')
      window.open(`https://wa.me/91${number}?text=${text}`, '_blank')
    }
  },

  setup(props) {
    const statusOptions = [
      { label: 'Pending', value: 'PENDING' },
      { label: 'Resolved', value: 'RESOLVED' }
    ]

    const contacts = [
      { name: 'Allahabad & Rest of UP', number: '+91 7518318623' },
      { name: 'Lucknow', number: '+91 8934992226' },
      { name: 'Punjab & Haryana', number: '+91 9007632595' },
      { name: 'Delhi NCR', number: '+91 9007632595' },
      { name: 'Head Office', number: '+91 7003045534' }
    ]

    const {
      fetchTickets,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,
      statusFilter,
      refetchData
    } = useSupportTicket({ type: props.type })

    return {
      fetchTickets,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,
      statusFilter,
      statusOptions,
      refetchData,
      contacts
    }
  }
}
</script>
